
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Area</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitArea(benefitGroupForm)" #benefitGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="area.code" [(ngModel)]="area.code">
								<mat-error>{{ violations['area.code'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="area.description" [(ngModel)]="area.description">
								<mat-error>{{ violations['area.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-slide-toggle [(ngModel)]="area.active"  name="areaActive" > 
							  {{ area.active? 'Area Activa':'Area Inactiva'}} 
							</mat-slide-toggle>
						</div>

					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(area.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>